const SOURCE_URL_PROTOCOLS = new Set(["https:", "http:"]);

export function safeSourceUrl(value: unknown): string | null {
  if (typeof value !== "string") {
    return null;
  }
  try {
    const url = new URL(value);
    if (
      !SOURCE_URL_PROTOCOLS.has(url.protocol) ||
      url.username ||
      url.password
    ) {
      return null;
    }
    return url.href;
  } catch {
    return null;
  }
}
